import React, {useEffect, useState} from 'react';
import DocAvatar from '@comp/CustomImg';
import FastVideoTip from '@comp/FastVideoTip';
import {host} from '@utils/hostConf';
import {decodeSign} from '@utils/tools';
import ImgMedia from '@/assets/icons/media.png';
import ImgRz from '@/assets/icons/e_renzheng_icon.png';
import ImgTj from '@/assets/icons/e_xingjituijian.png';

import './index.less';

const Doctor = function (props) {
  const docInfo = props.data;
  const [videoPopupVisible, setVideoPopupVisible] = useState(false);

  const getDocImg = () => {
    return docInfo.doctor_img ? host.dr_img + docInfo.doctor_img : '/assets/img/i-doctor-head-default.png';
  };

  const renderDocImgVideo = () => {
    return docInfo.video_url ? (
      <div
        className="btn-show-video"
        onClick={() => {
          onClickToggleVideo(true);
        }}
      >
        <img src={ImgMedia} alt="" />
      </div>
    ) : null;
  };

  const renderHistory = () => {
    const {doctor_id, treat_num, fans_num, total_comment} = docInfo;
    return (
      <div className="d-flex">
        {/* <div className="flex-1">
          <strong className="num">{+(treat_num ? treat_num : 0) + (doctor_id == 122694 ? 523 : 0)}</strong>
          <span className="title-txt">接诊量</span>
        </div> */}
        <div className="flex-1">
          <strong className="num">{+(fans_num ? fans_num : 0) + (doctor_id == 122694 ? 469 : 0)}</strong>
          <span className="title-txt">粉丝数</span>
        </div>
        <div className="flex-1">
          <strong className="num">{+(total_comment ? total_comment : 0) + (doctor_id == 122694 ? 483 : 0)}</strong>
          <span className="title-txt">口碑量</span>
        </div>
      </div>
    );
  };

  //渲染医生视频
  const renderDocVideo = () => {
    if (docInfo.video_url) {
      return videoPopupVisible ? (
        <div className="doc-video-popup">
          <div className="btn-close-video" onClick={() => onClickToggleVideo(false)} />
          <iframe title="doc-video" width={'100%'} frameBorder="0" src={docInfo.video_url} allowFullScreen={true} />
        </div>
      ) : null;
    } else {
      return null;
    }
  };

  const onClickToggleVideo = (show) => {
    setVideoPopupVisible(show);
  };

  const domTuijian = (doctor_sign_extension) =>
    decodeSign(doctor_sign_extension, 8) ? <img className="img-icon-xingjituijian" src={ImgTj} alt="" /> : null;

  const hasFastVideo = (video_fee, doctor_sign_extension) => video_fee && video_fee !== '0' && decodeSign(doctor_sign_extension, 11);

  return (
    <article className="doctor-info">
      <div className="doctor-header">
        <div className="portrait-wrp">
          <DocAvatar imgProps={{className: 'portrait'}} src={getDocImg()} extra={renderDocImgVideo()} />
        </div>
        <div className="doc-name">
          <strong>{docInfo.doctor_name}</strong>
          <span>{docInfo.doctor_title}</span>
          <img className="img-icon-renzheng" src={ImgRz} alt="" />
          {/*{domTuijian}*/}
        </div>
        {docInfo.doctor_hospital ? (
          <div className="ex-hospital">
            <span>前医院: </span>
            <span>{docInfo.doctor_hospital}</span>
          </div>
        ) : (
          <div className="ex-hospital">
            <span>医院: </span>
            <span>{docInfo.doc2shop_list && docInfo.doc2shop_list[0].shop_name}</span>
          </div>
        )}
        <div>{renderHistory()}</div>
      </div>
      {renderDocVideo()}

      <FastVideoTip show={hasFastVideo} docDetail={docInfo} />
    </article>
  );
};

export default Doctor;
